import { useQuery, type QueryKey } from '@tanstack/react-query';
import { useAppCustomers } from '@/hooks/useAppCustomers';
import { QUERY_KEYS } from '@/api/queryKeys';

export const useProductImageryQuery = <T>(
  key: QueryKey,
  load: () => Promise<T>,
  poll: false | ((data: T) => number | false) = false,
) => {
  const { customerIds, userPermissions, hasGbaAdminAccess } = useAppCustomers();
  return useQuery({
    queryKey: [QUERY_KEYS.productImagery, customerIds, userPermissions, ...key],
    queryFn: load,
    enabled: userPermissions.loaded && hasGbaAdminAccess,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchInterval: (query) =>
      query.state.error || !query.state.data || !poll
        ? false
        : poll(query.state.data),
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
